import React from "react";
import "./kavling.scss";
import produkcard from "../../../../../component/cardkav/cardhome.json";
import Cardkav from "../../../../../component/cardkav/cardkav.jsx";
import Kavlinga from "../../../../../assets/kavling/kavling.js";

const kavling = () => {
  return (
    <div id="kavling" className="kavling">
      <div className="container-kavling">
        <div className="header-kav">
          <div className="judul1">NEW OFFERS</div>
          <div className="judul2">Kavling Residential di Dalam Cluster</div>
        </div>
        <div className="cardkav-container">
          {produkcard.Cardkavling.map((cards, index) => {
            // Determine the logo dynamically
            const fotorumah = Kavlinga[cards.imagerumah];
            return (
              <Cardkav
                key={index}
                imagerumah={fotorumah} // Dynamically import logo images
                titlerumah={cards.titlerumah}
                subtitlerumah={cards.subtitlerumah}
                details={cards.details}
                whatsappLink={cards.whatsappLink} // Pass the WhatsApp link// Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default kavling;
